:host {
  --cms-content-grid-area: var(--cms-default-grid-area);
  @include cms-components-host-defaults;
}

.content-wrapper {
  @include cms-default-grid-container;
}

cms-headline {
  grid-area: var(--cms-content-grid-area);
}

.content-without-campaign {
  color: var(--cms-theme-text-color);
  grid-area: var(--cms-content-grid-area);
  text-align: center;
  font-weight: var(--cms-base-font-weight-700);
  margin: var(--cms-spacing-075);
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: var(--cms-spacing-050);
  padding-right: var(--cms-spacing-050);
  font-size: var(--cms-font-size-112);
  line-height: var(--cms-line-height-111);
}

@include media-width($breakpoint-sm) {
  :host {
    --cms-content-grid-area: auto / 3 / auto / span 8;
  }

  :host([use-in-campaign='true']) {
    --cms-content-grid-area: auto / 2 / auto / span 10;
  }
}